import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-content.scss";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {CustomerPopup} from "../../../../panel/components/components/customer/popup/types/CustomerPopup";
import {WebsiteBlackFlowComponent} from "../black/flow/WebsiteBlackFlowComponent";
import {WebsiteBlackTextComponent} from "../black/text/WebsiteBlackTextComponent";
import {WebsiteBlackStepsComponent} from "../black/steps/WebsiteBlackStepsComponent";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {Resources} from "../../../../../resources/Resources";
import {WebsiteBlackUnionLineComponent} from "../black/union/line/WebsiteBlackUnionLineComponent";
import {WebsiteBlackPlatformHomeComponent} from "../black/platform/models/WebsiteBlackPlatformHomeComponent";
import {WebsiteIssuesComponent} from "../white/issues/WebsiteIssuesComponent";
import {Network} from "../../../../../network/Network";
import {config} from "../../../../../config";

export class WebsiteContentPrestashopModuleComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.prestaModuleDownloadFree"),
                            center: true,
                            title: Resources.t("words.prestaModuleFullFreeBlog"),
                            description: Resources.t("words.prestaModuleFullFreeBlogDescription"),
                            partnerIcon: "prestashop",
                            secondButton: true,
                            downloadLink: Network.vendor + config.prestaShopModuleLink,
                            firstButtonLink: Network.vendor + config.prestaShopModuleLink
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackStepsComponent({
                            title: "Aperçu du module",
                            icon: "prestashop",
                            contents: [
                                {
                                    name: Resources.t("words.managementInPrestaShop"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-j.mp4"),
                                    duration: 20000
                                },
                                {
                                    name: Resources.t("words.finalRender"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-k.mp4"),
                                    duration: 7000
                                },
                            ]
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackFlowComponent({
                                title: Resources.t("words.prestaModuleYourBlog"),
                                bigTitle: Resources.t("words.prestaModuleSeoTrafficBoost"),
                                image: NetworkVendor.image("blog-ag.webp"),
                                texts: {
                                    canCollapse: false,
                                    entries: [
                                        {
                                            title: Resources.t("words.fullInterface"),
                                            description: Resources.t("words.prestaModuleFeatureRichBlog"),
                                            icon: "pageSimple",
                                            iconColor: "colorBlack"
                                        },
                                        {
                                            title: Resources.t("words.seoFriendly"),
                                            description: Resources.t("words.prestaModuleBestSeoTool"),
                                            icon: "target",
                                            iconColor: "colorBlack"
                                        },
                                        {
                                            title: Resources.t("words.compatibleWithExistingBlog"),
                                            description: Resources.t("words.prestaModuleBlogCompatibility"),
                                            icon: "pageBlog",
                                            iconColor: "colorBlack"
                                        }
                                    ]
                                }
                            }))}
                        </div>
                    </div>
                </div>
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackTextComponent({
                            text: Resources.t("words.prestaModuleFreeAndSeoCompatible"),
                            size: "sizeBig",
                        }))}
                        ${this.draw(new WebsiteBlackUnionLineComponent("white"))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPlatformHomeComponent(true))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteIssuesComponent({
                            theme: "black",
                            questions: [
                                {
                                    question: Resources.t("words.prestaModuleWhatIsModule"),
                                    response: Resources.t("words.prestaModuleWhatIsModuleAnswer")
                                },
                                {
                                    question: Resources.t("words.prestaModuleHowToInstall"),
                                    response: Resources.t("words.prestaModuleHowToInstallAnswer")
                                },
                                {
                                    question: Resources.t("words.prestaModuleIsItFree"),
                                    response: Resources.t("words.prestaModuleIsItFreeAnswer")
                                }]
                        }))}
                    </div>
                </div>
            </div>
        `;
    }

    commit() {
        CustomerPopup.blog();
        super.commit();
    }
}



